<template>
  <div class="dm-body">
    <div class="dm-body-main" ref="bgMain">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
export default {
  mounted() {
    this.$nextTick(() => {
      // this.resize();
      window.addEventListener("resize", () => {
        // this.resize();
      });
    });
  },
  computed: {
    // ...mapGetters(["sidebar"]),
    // sideBarOpen: {
    //   get() {
    //     return this.sidebar.opened;
    //   },
    // },
  },
  watch: {
    // sideBarOpen(newValue) {
    //   setTimeout(() => {
    //     this.resize();
    //   }, 200);
    // },
  },
  methods: {
    resize() {
      if (this.$refs.bgMain) {
        let wScale = this.$refs.bgMain.clientWidth / 1677;
        const minScale = 800 / 1677;
        if (wScale < minScale) {
          wScale = minScale;
        }
        if (this.$refs.bgMain) {
          this.$refs.bgMain.style.transform =
            "scaleX(" + wScale + ") scaleY(" + wScale + ")";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dm-body {
  // overflow-y: auto;
  // overflow-x: auto;
  // height: calc(100vh - 50px);
  // overflow: hidden;
}
.dm-body-main {
  // padding: 25px 45px;
  min-width: 800px;
  transform-origin: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/MainArea.vue